import { ChevronRight } from 'lucide-react';

export interface FaqItemProps {
  /** The FAQ's question, verbatim. It wraps; never truncate. */
  question: string;
  /** True for the question currently answered in the thread. */
  selected?: boolean;
  onClick: () => void;
}

/**
 * One question: a compact list row with a hairline separator and a chevron on hover
 * only. Selected is a 2px navy left bar (inset shadow, so text never shifts) plus a
 * 6% navy tint.
 */
export function FaqItem({ question, selected = false, onClick }: FaqItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={selected ? 'true' : undefined}
      className={[
        'group flex w-full items-start gap-2.5 border-0 border-b border-[#e5e7eb] px-[18px] py-[13px] text-left',
        'focus-visible:ring-[3px] focus-visible:ring-dvaOrange/35 focus-visible:outline-none',
        selected ? 'bg-dvaNavy/[0.06] shadow-[inset_2px_0_0_#18365E]' : 'bg-transparent hover:bg-dvaNavy/[0.04]',
      ].join(' ')}
    >
      <span className={['grow text-sm leading-[1.4] text-dvaNavy', selected ? 'font-semibold' : 'font-medium'].join(' ')}>
        {question}
      </span>

      <ChevronRight
        aria-hidden="true"
        strokeWidth={selected ? 2.4 : 2.2}
        className={[
          'mt-[3px] size-3.5 shrink-0 text-dvaNavy transition-opacity duration-100',
          selected ? 'opacity-100' : 'opacity-0 group-hover:opacity-100',
        ].join(' ')}
      />
    </button>
  );
}
